import { AxiosInstance } from 'axios';
import LoggingService from 'src/services/Logging.service';
import type { AgentConversation, AgentChatMessage } from './Agent.types';

const getAgentRoute = (convoId: string) => `/api/agent/chats/${convoId}` as const;

export default class AgentService {
  protected client: AxiosInstance;
  protected logger: LoggingService;
  private logError: (logMessage: string, error: unknown) => Error;

  constructor(client: AxiosInstance) {
    this.client = client;
    this.logger = new LoggingService(this.client);
    this.logError = (logMessage: string, error: unknown) => {
      // remote logging happens here
      // bubble the error with message back up to the view layer to notify the user
      this.logger.error(logMessage, error);
      return new Error(logMessage);
    };
  }

  public createChat() {
    const url = '/api/agent/chats';

    return this.client.post<{ convoId: string }>(url).then((resp) => {
      return resp.data;
    }).catch((err) => {
      throw this.logError('An error occurred creating chat', err);
    });
  }

  public addChat(convoId: string, newChat: AgentChatMessage) {
    const url = `${getAgentRoute(convoId)}/converse`;

    // TODO replace this with real appName
    return this.client.post<AgentChatMessage>(url, { ...newChat, appName: "Assortment" }).then((resp) => {
      return resp.data;
    }).catch((err) => {
      throw this.logError('An error occurred adding your chat message', err);
    });
  }

  public getChats(convoId: string) {
    const url = '/api/agent/chats';

    return this.client.get<AgentConversation[]>(url).then((resp) => {
      return resp.data;
    }).catch((err) => {
      throw this.logError('An error occurred retrieving chat messages', err);
    });
  }

  public getChat(convoId: string) {
    const url = `${getAgentRoute(convoId)}/chats`;

    return this.client.get<{ message: string }[]>(url).then((resp) => {
      return resp.data;
    }).catch((err) => {
      throw this.logError('An error occurred retrieving chat', err);
    });
  }
}
